import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "@/lib/queryClient";
import { BrowserRouter } from "react-router-dom";
import { ToastProvider } from "@/ui";
import { CurrencyProvider } from "@/features/currency/CurrencyProvider";

export default function Providers({ children }: { children: React.ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <CurrencyProvider>
          <ToastProvider>{children}</ToastProvider>
        </CurrencyProvider>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
